import {useCallback, useMemo} from 'react';
import {requestContext} from '../../../../common/requestContext';
import {twMerge} from '../../../../common/twMerge';
import {useIsResponsiveFoldable} from '../../../../common/useIsResponsiveFoldable.hook';
import useTypedDispatch from '../../../../common/useTypedDispatch';
import useTypedSelector from '../../../../common/useTypedSelector';
import {setIsIpxMediaMuted} from '../../../../config/configSlice';
import {ThumbnailRatio} from '../../../../design-system/molecules/ThumbnailWithBadges/ThumbnailRatio.constant';
import {ThumbnailType} from '../../../../design-system/molecules/ThumbnailWithBadges/ThumbnailType.enum';
import {BannerItem} from '../../../../design-system/organisms/BannerItem/BannerItem';
import {getPosterViewMetaBoxHeight} from '../../../../design-system/organisms/PosterViewItem/getPosterViewMetaBoxHeight.function';
import {
  BannerItem as BannerItemType,
  ItemType,
} from '../../../../graphql/generated/types';
import {theme} from '../../../../theme';
import {CommonItemProps} from '../../type';

export function StandaloneBanner({item}: CommonItemProps) {
  const {
    bannerType,
    thumbnail,
    badgeList,
    statusBadge,
    title,
    videoUrl,
    caption,
    metaList,
    bannerViewType,
    titleImage,
  } = item as BannerItemType;
  const {isMobile} = requestContext.requestInfo.display;
  const isFoldable = useIsResponsiveFoldable();
  const subCardType = useTypedSelector(state => {
    const itemRelationInfo = state.pagewebLayout.relations.items[item.id];
    const parentId = itemRelationInfo.parentId;
    const subCardType = state.pagewebLayout.bannerInfo.subCardType[parentId];
    return subCardType || ItemType.CardView;
  });
  const wideScreenCss = useMemo(() => {
    const paddingBottom = `calc(${
      subCardType === ItemType.PosterView
        ? getPosterViewMetaBoxHeight()
        : `${ThumbnailRatio[ThumbnailType.Card] * 100}%`
    } / 3)`;
    return {
      paddingLeft: '3px',
      paddingRight: '3px',
      ':before': {
        display: 'block',
        content: '""',
        paddingBottom,
      },
    };
  }, [subCardType]);

  const isVideoMuted = useTypedSelector(state => state.config.isIpxMediaMuted);
  const dispatch = useTypedDispatch();
  const onVideoMutedChange = useCallback(
    (isMuted: boolean) => {
      dispatch(setIsIpxMediaMuted(isMuted));
    },
    [dispatch]
  );
  return (
    <div
      className="relative"
      style={{
        [`@media (min-width: ${theme.screens.foldable})`]: wideScreenCss,
        ...(!isMobile && wideScreenCss),
      }}
    >
      <BannerItem
        bannerType={bannerType}
        bannerImageSrc={thumbnail}
        bannerVideoSrc={videoUrl}
        viewType={bannerViewType}
        titleText={title}
        badgeList={badgeList}
        statusBadge={statusBadge}
        metaList={metaList}
        caption={caption}
        isSelected={true}
        className={twMerge(
          'foldable:absolute foldable:top-0 foldable:left-0 foldable:h-full foldable:w-full',
          !isMobile && 'absolute top-0 left-0 h-full w-full'
        )}
        isStandaloneBanner={true}
        isMuted={isVideoMuted}
        onVideoMutedChange={onVideoMutedChange}
        isMobile={isMobile}
        isFoldable={isFoldable}
        titleImageSrc={titleImage}
      />
    </div>
  );
}
